import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "@/lib/firebase";

export interface ImageUploadResult {
  url: string;
  path: string;
}

/**
 * Sube un blob de imagen a Firebase Storage.
 * Compatible con el servicio de mobile (misma estructura de carpetas).
 */
export async function uploadImage(
  blob: Blob,
  folder: string,
  fileName?: string
): Promise<ImageUploadResult> {
  const finalFileName =
    fileName || `image_${Date.now()}_${Math.random().toString(36).slice(2, 11)}.jpg`;
  const imagePath = `${folder}/${finalFileName}`;
  const imageRef = ref(storage, imagePath);
  await uploadBytes(imageRef, blob);
  const url = await getDownloadURL(imageRef);
  return { url, path: imagePath };
}
